import config from "src/config";
import { ResponseDto } from 'src/dtos/common/responseDto';
import { EmployeeDto } from "src/dtos/employee/employeeDto";
import { getData } from 'src/utils/axios/serverHelper';

const baseUrl = `${config.apiUrl}/employee`;

//조직 조회
export const getEmployeeList = async (searchText?: string) => {
  const url = `${baseUrl}/list`

  return await getData<ResponseDto<EmployeeDto[]>>(url, searchText ? {
    params: {
      searchText
    }
  } : undefined);
}